const getTokenFromLocalStorage = () => {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
};

export const config = {
  get headers() {
    return {
      Authorization: `Bearer ${
        getTokenFromLocalStorage() !== null
          ? getTokenFromLocalStorage().token
          : ""
      }`,
      Accept: "application/json",
    };
  },
};
